/**
 * DreamPay Private API
 * Private API v2 - Current version with JWT authentication, role-based access control, and enhanced security features.
 *
 * The version of the OpenAPI document: v2
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface RedeReportRowV2 {
  id?: number;
  date?: string;
  time?: string;
  status?: string;
  originalValue?: number;
  updatedValue?: number | null;
  modality?: string;
  type?: string;
  installments?: number;
  cardBrand?: string;
  mdrRate?: number | null;
  mdrValue?: number;
  autoReceivingRate?: number | null;
  autoReceivingValue?: number | null;
  totalFeesRate?: number | null;
  totalFeesValue?: number | null;
  netValue?: number | null;
  nsu?: string;
  receivingTerm?: string;
  batchNumber?: string;
  authorizationCode?: string;
  establishmentNumber?: string;
  establishmentName?: string;
  cnpj?: string;
  cardNumber?: string;
  digitalWalletId?: string;
  paymentMethod?: string;
  terminalType?: string;
  terminalCode?: string;
  tid?: string;
  orderNumber?: string;
  boardingFee?: number;
  canceledByEstablishment?: boolean;
  cancellationDate?: string | null;
  canceledValue?: number | null;
  inChargebackDispute?: boolean;
  chargebackDisputeDate?: string | null;
  chargebackResolution?: string;
  chargebackResolutionDate?: string | null;
  cardNationality?: string;
  foreignCurrencyDcc?: boolean;
  prepaidCard?: boolean;
  redeTransactionId?: string;
  rowIndex?: number;
}
